/**
 * Crea tokens de color semánticos para iconos de tipo de archivo
 * Estos colores son usados por FileThumbnail y FilePreviewList
 *
 * @param {Object} theme - MUI theme object
 * @returns {Object} File icon color tokens
 */
export const createFileIconTokens = (theme) => {
  const isDark = theme.palette.mode === 'dark';

  return {
    // Documentos PDF - Rojo (asociación universal con PDF/Adobe)
    pdf: isDark
      ? theme.palette.error.light
      : theme.palette.error.main,

    // Documentos de texto (Word, etc.) - Azul (asociación con Microsoft Word)
    document: isDark
      ? theme.palette.info.light
      : theme.palette.info.main,

    // Hojas de cálculo (Excel, etc.) - Verde (asociación con Microsoft Excel)
    spreadsheet: isDark
      ? theme.palette.success.light
      : theme.palette.success.main,

    // Código fuente - Naranja (convención de editores de código)
    code: isDark
      ? theme.palette.warning.light
      : theme.palette.warning.main,

    // Archivos comprimidos (zip, rar, etc.) - Púrpura
    archive: isDark
      ? theme.palette.secondary.light
      : theme.palette.secondary.main,

    // Imágenes - Cyan/Info claro
    image: isDark
      ? theme.palette.info.light
      : theme.palette.info.main,

    // Audio - Púrpura más oscuro
    audio: isDark
      ? theme.palette.secondary.light
      : theme.palette.secondary.dark,

    // Video - Rosa/Magenta
    video: isDark
      ? '#F48FB1'  // pink.200
      : '#C2185B', // pink.700

    // Genérico/Desconocido - Gris
    generic: theme.palette.grey[isDark ? 400 : 600],

    // Badge de tamaño de archivo (para overlay en thumbnails)
    // Opacidad máxima (95%) para garantizar contraste sobre cualquier imagen
    // Cumple WCAG AA (4.5:1) incluso sobre fondos muy claros
    sizeBadge: {
      background: 'rgba(0, 0, 0, 0.95)',
      text: '#FFFFFF'
    }
  };
};
